import CellRef from "./CellRef";
import Nemo from "./Nemo";
import CellFile from "./CellFile";
import Dashboard from "./Dashboard";
import Import from "./Import";
import KML from "./KML";
import View from "./View";
import Borders from "./Borders";
import AtollCheck from "./AtollCheck";
import AtollDownload from "./AtollDownload";
import Violation from "./Violation";
import FileAnalyze from "./FileAnalyze";
import AtollUpdate from "./AtollUpdate";
import EP_Report from "./EP_Report"
const Planning = {
  CellRef,
  Nemo,
  CellFile,
  Dashboard,
  Import,
  KML,
  View,
  AtollCheck,
  AtollDownload,
  Borders,
  Violation,
  FileAnalyze,
  AtollUpdate,
  EP_Report
};

export default Planning;
